var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39954 4.46803C8.63335 4.46803 9.63355 3.46782 9.63355 2.23401C9.63355 1.0002 8.63335 0 7.39954 0C6.16573 0 5.16553 1.0002 5.16553 2.23401C5.16553 3.46782 6.16573 4.46803 7.39954 4.46803Z",
    fill: "#00B66A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2396 4.46803C14.4734 4.46803 15.4736 3.46782 15.4736 2.23401C15.4736 1.0002 14.4734 0 13.2396 0C12.0058 0 11.0056 1.0002 11.0056 2.23401C11.0056 3.46782 12.0058 4.46803 13.2396 4.46803Z",
    fill: "#00B66A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6532 7.59852C3.88701 7.59852 4.88722 6.59832 4.88722 5.36451C4.88722 4.13069 3.88701 3.13049 2.6532 3.13049C1.41939 3.13049 0.419189 4.13069 0.419189 5.36451C0.419189 6.59832 1.41939 7.59852 2.6532 7.59852Z",
    fill: "#00B66A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2101 7.59852C19.4439 7.59852 20.4441 6.59832 20.4441 5.36451C20.4441 4.13069 19.4439 3.13049 18.2101 3.13049C16.9763 3.13049 15.9761 4.13069 15.9761 5.36451C15.9761 6.59832 16.9763 7.59852 18.2101 7.59852Z",
    fill: "#00B66A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5127,
    cy: 12.4688,
    r: 6.53125,
    fill: "#00B66A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPad);
export default __webpack_public_path__ + "static/media/pad.8bf1467fe7d95c9f93cf2e6c29d367c5.svg";
export { ForwardRef as ReactComponent };